export default __webpack_public_path__ + "c5f0ce1417d4c453b0c7e44c10598ea2.png";